'use client';

import { Button } from '@shared/components/shadcn';
import { Reload } from '@shared/icons';
import { useTranslations } from 'next-intl';

type ReplayDrawButtonProps = Readonly<{
  onClick: () => void;
}>;

/**
 * Player control to start or restart a live-draw playback (WEBD-949, WEBD-1528).
 *
 * Matches Daily Million Figma: secondary small button with a left Reload icon.
 */
function ReplayDrawButton({ onClick }: ReplayDrawButtonProps) {
  const t = useTranslations('lotteries.results.live_draw');

  return (
    <Button type="button" variant="secondary" size="s" className="w-full gap-2" data-testid="replay-draw-button" data-track-name="Replay draw" onClick={onClick}>
      <Reload size="extra-small" aria-hidden />
      {t('replay_draw')}
    </Button>
  );
}

export { ReplayDrawButton };
export type { ReplayDrawButtonProps };
